import React, { useEffect } from 'react';
import { Button, Modal } from 'is24-corecss';
import { getErrorMessage } from '../../../../common/statusMesssages';
import { StatusMessageType } from '../../types/StatusMessageType';
import { performLifecycleTransition } from '../../../../api/TeamApi';
import { reportViewEvent } from '../../../../tracking/tracking';

type StartAccountPersonalizationModalProps = {
  visible: boolean;
  onClose: () => void;
  onPersonalizationStarted: (status?: StatusMessageType) => void;
};

const StartAccountPersonalizationModal: React.FC<StartAccountPersonalizationModalProps> = ({
  visible,
  onClose,
  onPersonalizationStarted,
}: StartAccountPersonalizationModalProps) => {
  useEffect(() => {
    visible && reportViewEvent({ pageTitle: 'primary_account_change' });
  }, [visible]);

  const handleStartAccountPersonalization = async () => {
    try {
      const lifecycleSnapshot = await performLifecycleTransition({ command: 'teamStartPersonalization' });
      const transition = lifecycleSnapshot.possibleTransitions.find((element) => !!element['teamStartPersonalization']);
      const maybeRedirectToUrl = transition?.teamStartPersonalization?.precondition?.redirectTo;
      onPersonalizationStarted();
      maybeRedirectToUrl && window.location.assign(maybeRedirectToUrl as string);
    } catch (e) {
      onPersonalizationStarted(getErrorMessage(e));
    }
  };

  return (
    <Modal visible={visible} onClose={onClose} title='Zugangsdaten vom Hauptkonto ändern'>
      <div data-testid='personalization-confirmation-text' className='grid-item one-whole padding-bottom-l'>
        <p className='font-bold'>Wichtig für CRM-Systeme</p>
        <p>
          Benutzen Sie diese Zugangsdaten auch für die Authentifizierung Ihres CRM-Systems mit ImmoScout24, wird diese Verbindung nach der Vergabe
          eines neuen Passwortes getrennt. Sie müssen diese Verbindung mit Ihrem neuen Passwort in Ihrem CRM-System wiederherstellen.
        </p>
      </div>
      <div className='grid grid-flex grid-justify-space-between margin-top-m'>
        <Button data-testid='cancel-personalization-button' onClick={onClose}>
          Abbrechen
        </Button>
        <div className='palm-one-whole margin-top-l desk-hide lap-hide' />
        <Button data-testid='perform-personalization-button' appearance='primary' onClick={handleStartAccountPersonalization}>
          Zugangsdaten ändern
        </Button>
      </div>
    </Modal>
  );
};

export default StartAccountPersonalizationModal;
